import { render, staticRenderFns } from "./SideOrdersSelect.vue?vue&type=template&id=768ad18b&scoped=true&lang=html&"
import script from "./SideOrdersSelect.vue?vue&type=script&lang=js&"
export * from "./SideOrdersSelect.vue?vue&type=script&lang=js&"
import style0 from "./SideOrdersSelect.vue?vue&type=style&index=0&id=768ad18b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768ad18b",
  null
  
)

export default component.exports